export default "__VITE_ASSET__C7N15bMG__"